/** Shared shell for onboarding steps — same centered width as Items/Storage/Suppliers. */
export const onboardingStepShellClass =
  'mx-auto w-full max-w-[880px] space-y-6';

/** Two equal columns used on Items, Storage, and Suppliers. */
export const onboardingDualPanelGridClass =
  'grid grid-cols-1 items-start gap-6 lg:grid-cols-2 lg:h-[min(70vh,640px)] lg:items-stretch lg:gap-x-10';
